import { useEffect, useState } from 'react';
import { StyledTable } from 'components/styledComponents/table/Table.styled';
import { StyledSkeleton } from 'shared/Common.styled';
import type { TableProps } from 'antd';
import { AdminTableProps } from './AdminTable';

const skeletonTimeout = 15000;

const AdminTableSkeleton = <T extends object, >({ columns, size = 'small' }: AdminTableProps<T>) => {
  const [showSkeleton, setShowSkeleton] = useState<boolean>(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowSkeleton(false);
    }, skeletonTimeout);

    return () => clearTimeout(timeout); // Cleanup
  }, []);

  return (
    <StyledTable
      rowKey="key"
      pagination={false}
      size={size}
      dataSource={
        showSkeleton
          ? [
              {
                key: 0,
              } as T,
          ]
          : []
      }
      columns={columns?.map((column) => ({
        ...column,
        fixed: false,
        render: () => <StyledSkeleton key={column.key} $titleMaxWidth={200} active paragraph={false} $align={column.align} />,
      })) as TableProps['columns']}
    />
  );
};

export default AdminTableSkeleton;
